import { Team__Apaches } from "./teams/Apaches";
import { Team__FoxImpresos } from "./teams/FoxImpresos";
import { Team__Nogaleros } from "./teams/Nogaleros";
import { Team__Cerveceros } from "./teams/Cerveceros";
import { Team__Aliados } from "./teams/Aliados";
import { Team__FloresMagon } from "./teams/FloresMagon";
import { Team__Coyotes } from "./teams/Coyotes";
import { Team__LaChona } from "./teams/LaChona";

const GroupA1 = [
  Team__Coyotes,
  Team__LaChona,
  Team__Aliados,
  Team__Cerveceros,
];

const GroupA2 = [
  Team__FoxImpresos,
  Team__FloresMagon,
  Team__Apaches,
  Team__Nogaleros,
];

export const Groups_2026_A = [GroupA1, GroupA2];
